export const formatRainProbability = (rainProbability: number): string => {
  let rainProbabilityText = rainProbability?.toString();
  if (rainProbability > 95) {
    return (rainProbabilityText = ">95");
  } else if (rainProbability < 5) {
    return (rainProbabilityText = "<5");
  } else {
    return rainProbabilityText;
  }
};
